"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var v1_exports = {};
__export(v1_exports, {
  readOption: () => readOption,
  readOrFail: () => readOrFail,
  remove: () => remove,
  save: () => save
});
module.exports = __toCommonJS(v1_exports);
var import_types = require("@cartographerio/types");
var fetch = __toESM(require("../../../fetch.js"));
var import_response = require("../../../response.js");
const basePath = "/admin/notes/v1";
function readOrFail(apiParams, ref) {
  return fetch.get({ apiParams, url: { path: `${basePath}/${ref}` } }).flatMap(import_response.readAsJson).flatMap((0, import_response.contentAs)("AdminNote", import_types.isAdminNote));
}
function readOption(apiParams, ref) {
  return fetch.get({ apiParams, url: { path: `${basePath}/${ref}` } }).flatMap(import_response.readAsJson).flatMap((0, import_response.optionalContentAs)("AdminNote", import_types.isAdminNote));
}
function save(apiParams, ref, note) {
  return fetch.put({
    apiParams,
    url: { path: `${basePath}/${ref}` },
    body: note
  }).flatMap(import_response.readAsJson).flatMap((0, import_response.contentAs)("AdminNote", import_types.isAdminNote));
}
function remove(apiParams, ref) {
  return fetch.remove({ apiParams, url: { path: `${basePath}/${ref}` } }).void();
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  readOption,
  readOrFail,
  remove,
  save
});
//# sourceMappingURL=v1.js.map
